import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createRenamePlayerAdminActionOutbound } from '../../api/outbound/commonOutbounds';
import { useInstanceId } from '../../context/instance/instanceContext';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { FormControlContainer } from '../formControlContainer';
export const RenamePlayerAdminActionMessageBoxContents = ({ playerId, onClose }) => {
    const instanceId = useInstanceId();
    const socketSend = useSocketSend();
    const [newUsername, setNewUsername] = useState('');
    const onChangeNewUsername = (event) => {
        setNewUsername(event.target.value);
    };
    const onClickRename = useCallback(() => {
        socketSend(createRenamePlayerAdminActionOutbound(playerId, newUsername));
        onClose();
    }, [socketSend, playerId, newUsername, onClose]);
    return (_jsxs(_Fragment, { children: [_jsxs(DialogContentText, { children: ["This is an", ' ', _jsx("strong", { children: _jsx("em", { children: "Admin Action" }) }), ' ', "and will be recorded as such."] }), _jsx(FormControlContainer, { children: _jsx(TextField, { id: `new-username-${instanceId}`, variant: 'filled', fullWidth: true, label: 'New Username', value: newUsername, onChange: onChangeNewUsername }) }), _jsx(DialogActions, { children: _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickRename, children: "Rename" }) })] }));
};
